import React from 'react';

class Percentage extends React.Component
{
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
        return <React.Fragment>{this.props.value}%</React.Fragment>
    }
}

export default Percentage;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/Percentage.js